const DrawerIsChoosingAWordModal = () => {
    return (
        <div className='modal-overlay'>
            <div className='modal'>
               <h2>Drawer is choosing a word</h2>
            </div>
        </div>
    );
};

export default DrawerIsChoosingAWordModal;